import { CommonButton as Button } from 'components/common/Forms/Button';
import React, { ReactElement } from 'react';
import { UsersFilters } from 'types/users';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { SearchPatientDialog } from '../user/SearchPatientDialog';
import {
  SearchPatientTable,
  UserRowActionCreator,
} from '../user/SearchPatientTable';

interface Props {
  onClose: () => void;
  initialFilters?: Partial<UsersFilters>;
  stickyFilters?: Partial<UsersFilters>;
  rowActionsCreator: UserRowActionCreator;
}

export const SearchSelectPatientDialog = ({
  initialFilters = {},
  onClose,
  rowActionsCreator,
  stickyFilters,
}: Props): ReactElement => {
  const { t } = useCommonTranslation();
  return (
    <SearchPatientDialog>
      <SearchPatientTable
        stickyFilters={stickyFilters}
        initialFilters={{
          sortField: 'lastname',
          sortDirection: 'asc',
          ...initialFilters,
        }}
        filtersDisplayed={[
          'firstname',
          'lastname',
          'email',
          'phone',
          'birthDate',
        ]}
        rowActionsCreator={rowActionsCreator}
        underTableElement={
          <Button
            variant="danger"
            onClick={onClose}
            style={{
              marginTop: 'var(--s3)',
            }}
          >
            {t('close-search-results')}
          </Button>
        }
      />
    </SearchPatientDialog>
  );
};
